t = require('views/internal/teacup-with-helpers')('list_sort')

module.exports = t.renderable ({ canSortByDueDate, pluginListSorters }) ->
  t.ul '.pop-over-list', ->
    t.li ->
      t.a '.js-sort-newest-first', { href: '#' }, ->
        t.format 'sort-newest-first'

    t.li ->
      t.a '.js-sort-oldest-first', { href: '#' }, ->
        t.format 'sort-oldest-first'

    t.li ->
      t.a '.js-sort-by-card-name', { href: '#' }, ->
        t.format 'sort-by-card-name'

    if canSortByDueDate
      t.li ->
        t.a '.js-sort-by-due-date', { href: '#' }, ->
          t.format 'due-date'

    if pluginListSorters?.length > 0
      t.hr()

      pluginListSorters.map (pluginSort, index) ->
        t.li ->
          t.a '.plugin-list-action.js-plugin-list-sort-action',
            'data-index': index
            href: '#'
            title: pluginSort.text
          , ->
            t.span -> t.text pluginSort.text
            if pluginSort.icon?
              t.icon pluginSort.icon
            else if pluginSort.image?
              t.img {
                src: pluginSort.image
                title: pluginSort.name
                height: '18px'
                width: '18px'
              }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/list_sort.coffee